import Table from "ds/components/Table";
import { Context } from "types/generated";
import { SortStateDescriptor } from "components/Filters/types";
import ContextsTableWrapper from "ds/components/Table/Wrapper";
import TableSkeleton from "ds/components/Table/Skeleton";

import ContextsTableHead from "./Head";
import ContextsTableBody from "./Body";
import useContextsTableStore from "./useContextsTableStore";

type ContextsTableProps = {
  contexts: Array<Context>;
  loadingContent?: boolean;
  rowsPerPage: number;
  sortCallback: (sortDescriptor: SortStateDescriptor) => void;
};

const ContextsTable = ({
  contexts,
  loadingContent,
  rowsPerPage,
  sortCallback,
}: ContextsTableProps) => {
  const visibleColumnsIds = useContextsTableStore((state) => state.columnsOrder.visible);

  return (
    <ContextsTableWrapper>
      <Table ariaLabel="Contexts table">
        <ContextsTableHead sortCallback={sortCallback} />
        {loadingContent && (
          <TableSkeleton columnIds={visibleColumnsIds} rowsPerPage={rowsPerPage} />
        )}
        {!loadingContent && <ContextsTableBody contexts={contexts} />}
      </Table>
    </ContextsTableWrapper>
  );
};

export default ContextsTable;
